import React from 'react';
import "./index.css";
import { plats } from "./data/Plats"

const PlatsAffichage = (props) => {

    return (
        <div id={props.id} className="menus-content">
            <h1>{props.nom}</h1>
            <div className="menus__inside">
                <ul className="ul_carte">
                    {
                        plats[props.index].plat.map((i, index) => {
                            return <li key={i}><span>{i}</span> <span className="dots"></span> <span className="carte_prix">{plats[props.index].prix[index]}</span></li>
                        })
                    }
                </ul>
            </div>
        </div>
    );

};

export default PlatsAffichage;